const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (!acc) return undefined;
    if (key.match(/^\\d+$/)) {
      if (typeof acc === "string") return undefined;
      return acc[Number(key)];
    }
    return acc[key];
  }, obj);
};

const ErrorMessage = ({ errors, touched, fieldName }) => {
  const error = getNestedValue(errors, fieldName);
  const isTouched = getNestedValue(touched, fieldName);
  return error && isTouched ? <span style={{ color: "red" }}>{error}</span> : null;
};

export default ErrorMessage
